import React, { useState } from 'react';
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Image,
} from 'react-bootstrap';

const AddNewPlanModal = ({
  show,
  onHide,
  profileImage,
  handleFileChange,
  handleCancelImage,
  planFormData,
  handleFormChange,
  // You can pass additional props if needed for modules checkboxes state etc.
}) => {
  // Local state for modules if not managed in parent (to keep old logic intact)
  const [selectedModules, setSelectedModules] = useState([]);

  const modulesList = [
    "Employees", "Invoices", "Reports", "Contacts",
    "Clients", "Estimates", "Goals", "Deals",
    "Projects", "Payments", "Assets", "Leads",
    "Tickets", "Taxes", "Activities", "Pipelines",
  ];

  const handleModuleChange = (module) => {
    if (selectedModules.includes(module)) {
      setSelectedModules(selectedModules.filter(m => m !== module));
    } else {
      setSelectedModules([...selectedModules, module]);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal"
      fullscreen="md-down" // Makes it fullscreen on mobile for better UX
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Plan</Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4">
        {/* Upload Profile Image Section - Matching image exactly */}
        <div
          style={{
            background: "#f5f6f8",
            padding: "20px",
            borderRadius: "8px",
            marginBottom: "24px",
            display: "flex",
            alignItems: "center",
            gap: "20px",
            flexWrap: "wrap",
          }}
          className="upload-section"
        >
          <Image
            src={profileImage || "https://via.placeholder.com/70?text=Profile"}
            alt="Profile"
            roundedCircle
            style={{
              width: "70px",
              height: "70px",
              objectFit: "cover",
            }}
          />

          <div style={{ flex: 1, minWidth: "200px" }}>
            <div style={{ fontWeight: "600", marginBottom: "4px" }}>
              Upload Profile Image
            </div>
            <div style={{ fontSize: "12px", color: "#888", marginBottom: "8px" }}>
              Image should be below 4 mb
            </div>

            <div>
              <input
                type="file"
                id="uploadProfile"
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept="image/*"
              />
              <label
                htmlFor="uploadProfile"
                style={{
                  background: "#f26522",
                  color: "#fff",
                  padding: "8px 16px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginRight: "12px",
                  display: "inline-block",
                }}
              >
                Upload
              </label>

              <Button
                size="sm"
                variant="light"
                onClick={handleCancelImage}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>

        {/* Form Fields - Made responsive and matching image layout */}
        <Row className="g-3">
          <Col md={6} xs={12}>
            <Form.Group>
              <Form.Label>Plan Name <span className="text-danger">*</span></Form.Label>
              <Form.Select
                name="name"
                value={planFormData.name || ""}
                onChange={handleFormChange}
                style={{ height: "44px", }}
              >
                <option value="">Select</option>
                <option value="Advanced">Advanced</option>
                <option value="Basic">Basic</option>
                <option value="Enterprise">Enterprise</option>
                <option value="Premium">Premium</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6} xs={12}>
            <Form.Group>
              <Form.Label>Plan Type <span className="text-danger">*</span></Form.Label>
              <Form.Select
                name="type"
                value={planFormData.type || ""}
                onChange={handleFormChange}
                style={{ height: "44px", }}
              >
                <option value="">Select</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6} xs={12}>
            <Form.Group>
              <Form.Label>Plan Position <span className="text-danger">*</span></Form.Label>
              <Form.Select
                name="position"
                value={planFormData.position || ""}
                onChange={handleFormChange}
                style={{ height: "44px", }}
              >
                <option value="">Select</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6} xs={12}>
            <Form.Group>
              <Form.Label>Plan Currency <span className="text-danger">*</span></Form.Label>
              <Form.Select
                name="currency"
                value={planFormData.currency || ""}
                onChange={handleFormChange}
                style={{ height: "44px", }}
              >
                <option value="">Select</option>
                <option value="USD">USD</option>
                <option value="EURO">EURO</option>
                <option value="INR">INR</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Price field with "Set 0 for free" hint */}
          <Col md={6} xs={12}>
            <Form.Group>
              <Form.Label>Plan Price <span className="text-danger">*</span></Form.Label>
              <div className="d-flex align-items-center gap-2">
                <Form.Control
                  name="price"
                  value={planFormData.price || ""}
                  onChange={handleFormChange}
                  type="number"
                  placeholder="0"
                  style={{ height: "44px" }}
                />
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    if (handleFormChange) {
                      const e = { target: { name: "price", value: "0" } };
                      handleFormChange(e);
                    }
                  }}
                >
                  Set 0 for free
                </Button>
              </div>
            </Form.Group>
          </Col>

          <Col md={3} xs={6}>
            <Form.Group>
              <Form.Label>Discount Type <span className="text-danger">*</span></Form.Label>
              <Form.Select
                name="discountType"
                value={planFormData.discountType || ""}
                onChange={handleFormChange}
                style={{ height: "44px" }}
              >
                <option value="">Select</option>
                <option value="Fixed">Fixed</option>
                <option value="Percentage">Percentage</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={3} xs={6}>
            <Form.Group>
              <Form.Label>Discount <span className="text-danger">*</span></Form.Label>
              <Form.Control
                name="discount"
                value={planFormData.discount || ""}
                onChange={handleFormChange}
                type="number"
                style={{ height: "44px" }}
              />
            </Form.Group>
          </Col>

          {/* Limitation fields */}
          <Col md={3} xs={6}>
            <Form.Group>
              <Form.Label>Limitations Invoices</Form.Label>
              <Form.Control
                name="limitInvoices"
                value={planFormData.limitInvoices || ""}
                onChange={handleFormChange}
                type="text"
                style={{ height: "44px" }}
              />
            </Form.Group>
          </Col>

          <Col md={3} xs={6}>
            <Form.Group>
              <Form.Label>Max Customers</Form.Label>
              <Form.Control
                name="maxCustomers"
                value={planFormData.maxCustomers || ""}
                onChange={handleFormChange}
                type="text"
                style={{ height: "44px" }}
              />
            </Form.Group>
          </Col>

          <Col md={3} xs={6}>
            <Form.Group>
              <Form.Label>Product</Form.Label>
              <Form.Control
                name="product"
                value={planFormData.product || ""}
                onChange={handleFormChange}
                type="text"
                style={{ height: "44px" }}
              />
            </Form.Group>
          </Col>

          <Col md={3} xs={6}>
            <Form.Group>
              <Form.Label>Supplier</Form.Label>
              <Form.Control
                name="supplier"
                value={planFormData.supplier || ""}
                onChange={handleFormChange}
                type="text"
                style={{ height: "44px" }}
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Plan Modules - Matching image */}
        <div className="mt-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">Plan Modules</h6>
            <Form.Check
              type="checkbox"
              label="Select All"
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedModules([...modulesList]);
                } else {
                  setSelectedModules([]);
                }
              }}
            />
          </div>

          <Row className="g-2">
            {modulesList.map((module) => (
              <Col md={3} sm={6} xs={6} key={module}>
                <Form.Check
                  type="checkbox"
                  label={module}
                  checked={selectedModules.includes(module)}
                  onChange={() => handleModuleChange(module)}
                  className="mb-2"
                />
              </Col>
            ))}
          </Row>
        </div>

        {/* Trial, Recommended, Status */}
        <Row className="mt-4 g-3">
          <Col md={4} xs={12}>
            <Form.Check
              type="switch"
              label="Access Trial"
              name="accessTrial"
              checked={planFormData.accessTrial || false}
              onChange={handleFormChange}
            />
          </Col>

          <Col md={4} xs={12}>
            <Form.Group>
              <Form.Label>Trial Days</Form.Label>
              <Form.Control
                name="trialDays"
                value={planFormData.trialDays || ""}
                onChange={handleFormChange}
                type="number"
                style={{ height: "44px" }}
              />
            </Form.Group>
          </Col>

          <Col md={4} xs={12}>
            <Form.Check
              type="switch"
              label="Is Recommended"
              name="isRecommended"
              checked={planFormData.isRecommended || false}
              onChange={handleFormChange}
            />
          </Col>

          <Col md={6} xs={12} className="mt-2">
            <Form.Group>
              <Form.Label>Status <span className="text-danger">*</span></Form.Label>
              <Form.Select
                name="status"
                value={planFormData.status || ""}
                onChange={handleFormChange}
                style={{ height: "44px" }}
              >
                <option value="">Select</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {/* Description */}
        <Form.Group className="mt-4">
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            name="description"
            value={planFormData.description || ""}
            onChange={handleFormChange}
            placeholder="Enter plan description..."
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          Cancel
        </Button>
        <Button
          style={{
            background: "#f26522",
            border: "none",
          }}
          onClick={() => {
            // Add your submit logic here or pass as prop
            console.log("Plan Data:", { ...planFormData, modules: selectedModules });
            onHide();
          }}
        >
          Add Plan
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddNewPlanModal;